import { useEffect, useState } from "react";

const initialState = {
  loading: true,
  hasWebcam: false,
  hasSpeakers: false,
  hasMicrophone: false,
  hasWebcamAcccess: false,
  hasMicrophoneAcccess: false,
};

const useMediaDevices = () => {
  const [permissions, setPermissions] = useState(initialState);

  useEffect(() => {
    if (!navigator.enumerateDevices && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      navigator.enumerateDevices = (callback) => {
        const enumerateDevices = navigator.mediaDevices.enumerateDevices();

        if (enumerateDevices && enumerateDevices.then) {
          navigator.mediaDevices.enumerateDevices().then(callback).catch(() => {
            callback([]);
          });
        } else {
          callback([]);
        }
      };
    }

    if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
      navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
    }

    if (!navigator.enumerateDevices) {
      return;
    }

    navigator.enumerateDevices((devices) => {
      const permissions = initialState;

      devices.forEach((device) => {
        if (device.kind === "videoinput" || device.kind === "video") {
          permissions.hasWebcam = true;

          if (device.label) {
            permissions.hasWebcamAcccess = true;
          }
        } else if (device.kind === "audioinput" || device.kind === "audio") {
          permissions.hasMicrophone = true;

          if (device.label) {
            permissions.hasMicrophoneAcccess = true;
          }
        } else if (device.kind === "audiooutput") {
          permissions.hasSpeakers = true;
        }
      });

      setPermissions({
        ...permissions,
        loading: false,
      });
    });
  }, []);

  return permissions;
};

export default useMediaDevices;
